<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: { type: Boolean, required: true },
  title: String,
  size: { type: String, default: 'medium' } // medium | large | xl
})

const emit = defineEmits(['update:modelValue', 'close'])

const closeModal = () => {
  emit('update:modelValue', false)
  emit('close')
}

const sizeClasses = computed(() => {
  switch (props.size) {
    case 'large': return 'w-full sm:w-3/4 md:w-2/3 lg:w-1/2'
    case 'xl':    return 'w-full sm:w-full md:w-3/4 lg:w-2/3'
    default:      return 'w-full sm:w-2/3 md:w-1/2 lg:w-1/3' // medium
  }
})
</script>

<template>
  <Teleport to="body">
    <!-- BACKDROP FADE -->
    <Transition name="fade">
      <div 
        v-if="modelValue"
        class="fixed inset-0 z-40 bg-black/50"
        @click="closeModal"
      ></div>
    </Transition>

    <!-- SLIDE-IN PANEL -->
    <Transition name="slide-right">
      <div
        v-if="modelValue"
        @click.stop
        :class="['fixed top-0 right-0 h-full bg-white shadow-2xl overflow-y-auto z-50', sizeClasses]"
      >
        <!-- Header -->
        <div class="flex items-center justify-between p-4 border-b border-gray-200">
          <h3 class="text-lg font-semibold text-gray-900">{{ title }}</h3>
          <button
            @click="closeModal"
            class="text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-lg w-8 h-8 flex items-center justify-center"
          >
            <svg class="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M1 1l6 6m0 0l6 6M7 7l6-6M7 7L1 13" />
            </svg>
          </button>
        </div>

        <slot />
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
/* BACKDROP FADE */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

/* SLIDE-IN FROM RIGHT */
.slide-right-enter-active, .slide-right-leave-active {
  transition: transform 0.3s ease-in-out;
}
.slide-right-enter-from, .slide-right-leave-to {
  transform: translateX(100%);
}
</style>
